<template>
  <div class="propertylist">
    <div class="list">
      <div class="item" v-for="item in propertylist" :key="item.id">
        <img :src="item.logo" alt="" />
        <div>{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import propertylist1 from "../../../../assets/product/propertylist1.png";
import propertylist2 from "../../../../assets/product/propertylist2.png";
import propertylist3 from "../../../../assets/product/propertylist3.png";
import propertylist4 from "../../../../assets/product/propertylist4.png";

export default {
  setup() {
    return reactive({
      propertylist: [
        {
          id: 1,
          logo: propertylist1,
          title: "移动办公",
        },
        {
          id: 2,
          logo: propertylist2,
          title: "协同办公",
        },
        {
          id: 3,
          logo: propertylist3,
          title: "物业急速响应",
        },
        {
          id: 4,
          logo: propertylist4,
          title: "实时智能分析",
        },
      ],
    });
  },
};
</script>

<style scoped>
.propertylist {
  width: 92vw;
  margin: 24px auto 0;
}
.propertylist .list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.propertylist .list .item  {
    text-align: center;
    overflow: hidden;
    margin-bottom: 20px;
}
.propertylist .list .item img {
    width: 82px;
    margin-bottom: 15px;
}
.propertylist .list .item div {
    font-size: 13px;
    color: #333;
    font-weight: 600;
}
</style>
